import Vue from "vue";


import Page_a31222b32b8189f869c2c2eeaa029d4f from "@/views/100_title.vue";

import Page_847fd889b9d10f2ef87e4bf67370765b from "@/views/200_Introductions.vue";

import Page_cabea64b490692bd1e990a8835348a8f from "@/views/300_Real_Life_Cybercrime.vue";

import Page_45ccadcc6295bae13658877135a0978b from "@/views/400_Cybercrime_Strategies.vue";

import Page_0c824769937c7b302d9c14d597297c53 from "@/views/500_Common_Digital_Attacks.vue";

import Page_31e0a374abeaa590da7685850a0aac8e from "@/views/600_Phishing_Attack_Exercise.vue";

import Page_ea1377274e39e981c75b52f89eee87d3 from "@/views/700_Internet_Based_Attacks.vue";

import Page_a6b02fe0521d632e61d60fbaafab437a from "@/views/800_Internet_Based_Attack_Exercise.vue";

import Page_6a5791d7d1e069fffae0f1169fa22e28 from "@/views/900_HR_Macro_Demo.vue";

import Page_908848599d28b603619f47ef7fdc4ef0 from "@/views/1000_Conclusion.vue";

import Page_1fe4e5e54864e734521d6d778b735239 from "@/views/1100_Quiz_Intro.vue";

import Page_7491cef0adcdb89dfdd886c0ae9ea19c from "@/views/1200_quiz.vue";

import Page_178f0d128f6629224a6591ce94ba12f0 from "@/views/1300_Congratulations.vue";



import QuizQuestion_c3e3b6805a8c7689d7b6d195311fd636 from "@/views/quiz/question-01.vue";




import BTB_INTRO from '@/views/BTB_INTRO.vue';
import BTB_OUTRO from '@/views/BTB_OUTRO.vue';
import BTB_INSERT_TEMPLATE from '@/views/BTB_INSERT_TEMPLATE.vue';


Vue.component("Page_a31222b32b8189f869c2c2eeaa029d4f", Page_a31222b32b8189f869c2c2eeaa029d4f);

Vue.component("Page_847fd889b9d10f2ef87e4bf67370765b", Page_847fd889b9d10f2ef87e4bf67370765b);

Vue.component("Page_cabea64b490692bd1e990a8835348a8f", Page_cabea64b490692bd1e990a8835348a8f);

Vue.component("Page_45ccadcc6295bae13658877135a0978b", Page_45ccadcc6295bae13658877135a0978b);

Vue.component("Page_0c824769937c7b302d9c14d597297c53", Page_0c824769937c7b302d9c14d597297c53);

Vue.component("Page_31e0a374abeaa590da7685850a0aac8e", Page_31e0a374abeaa590da7685850a0aac8e);

Vue.component("Page_ea1377274e39e981c75b52f89eee87d3", Page_ea1377274e39e981c75b52f89eee87d3);

Vue.component("Page_a6b02fe0521d632e61d60fbaafab437a", Page_a6b02fe0521d632e61d60fbaafab437a);

Vue.component("Page_6a5791d7d1e069fffae0f1169fa22e28", Page_6a5791d7d1e069fffae0f1169fa22e28);

Vue.component("Page_908848599d28b603619f47ef7fdc4ef0", Page_908848599d28b603619f47ef7fdc4ef0);

Vue.component("Page_1fe4e5e54864e734521d6d778b735239", Page_1fe4e5e54864e734521d6d778b735239);

Vue.component("Page_7491cef0adcdb89dfdd886c0ae9ea19c", Page_7491cef0adcdb89dfdd886c0ae9ea19c);

Vue.component("Page_178f0d128f6629224a6591ce94ba12f0", Page_178f0d128f6629224a6591ce94ba12f0);



Vue.component("QuizQuestion_c3e3b6805a8c7689d7b6d195311fd636", QuizQuestion_c3e3b6805a8c7689d7b6d195311fd636);




Vue.component('BTB_INTRO', BTB_INTRO);
Vue.component('BTB_OUTRO', BTB_OUTRO);
Vue.component('BTB_INSERT_TEMPLATE', BTB_INSERT_TEMPLATE);
